/* eslint max-len: ["error", 250] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import GoogleLogin from 'react-google-login'
import constant from '../../../constants'

export default class Google extends Component {
  responseGoogle = (response) => {
    this.props.onLoginResponse(response)
  }

  render() {
    return (
      <GoogleLogin
        clientId={constant.GOOGLE_CLIENT_ID}
        onSuccess={this.responseGoogle}
        onFailure={(error) => {}}
        className="join-with gg cursor-pointer xs-block xs-border-none"
        offline={false}
        prompt="consent"
      >
        <span className="join-text xs-pt3 xs-pl4 xs-float-left xs-text-black">{this.props.buttonText}</span>
        <span className="gg-logo xs-float-right xs-mx3 xs-my3" />
      </GoogleLogin>
    )
  }
}

Google.propTypes = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}

Google.defaultProps = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/social/google/google.js